import { useOrganizationStore } from '../../store/organization.store'
import { useState, useEffect, useRef } from 'react'
import { Box, MenuItem, Typography, Button, Menu, Tooltip } from '@mui/material'
import PropTypes from 'prop-types'
import { Icons } from '../../utils/utilities'

const SelectInstitute = ( { showDefault = true, containerStyles = {}, buttonStyles = {}, value, disabled, onSelect, message, showAllOption = false, size = "small" } ) => {
    const OrganizationStore = useOrganizationStore()

    const [instituteSelectOpen, setInstituteSelectOpen] = useState( false )
    const [isLoading, setIsLoading] = useState( true )

    const instituteSelectRef = useRef()

    const handleChange = ( value ) => {
        onSelect( value )
        setInstituteSelectOpen( false )
    }

    useEffect( () => {
        const getOrganizations = async () => {
            if ( OrganizationStore.getOrganization?.length === 0 )
                await OrganizationStore.fetchOrganization()
            setIsLoading( false )
        }
        getOrganizations()
    }, [OrganizationStore] )


    return (
        <Box sx={containerStyles}>
            <Tooltip title={message || "Select Institute"}>
                <Button size={size || 'size'} fullWidth disabled={disabled} onClick={() => setInstituteSelectOpen( true )} ref={instituteSelectRef} endIcon={Icons.default.KeyboardArrowDownIcon} variant='contained' disableElevation sx={{ height: "100%", justifyContent: "space-between", '&:disabled': { pointerEvents: "all", cursor: disabled && "not-allowed !important", }, background: `linear-gradient(125.39deg, #139CFF -32.54%, #C54097 110.4%)`, opacity: disabled ? 0.6 : 1, ...( buttonStyles || {} ) }} >
                    <Typography variant='subtitle2' color={disabled ? "lightgray" : "white"}>{isLoading ? "Loading Institutes" : !value ? "Institute" : value}</Typography>
                </Button>
            </Tooltip>
            <Menu anchorEl={instituteSelectRef.current} open={instituteSelectOpen} onClose={() => setInstituteSelectOpen( false )}>
                {showDefault && <MenuItem sx={{ fontSize: "12px" }} selected={!value || value === ""} value="">Select an institute</MenuItem>}
                {showAllOption && <MenuItem onClick={() => handleChange( "all" )} dense sx={{ fontSize: "12px" }} value="all">All Institute</MenuItem>}
                {
                    OrganizationStore.getOrganization.map( ( obj, i ) => {
                        return <MenuItem onClick={() => handleChange( obj.institute_name_short )} sx={{ fontSize: "12px", textTransform: "capitalize" }} selected={value === obj.institute_name_short} value={obj.institute_name_short} key={'key-' + i}> <strong>{obj.institute_name_short}</strong> - {obj.institute_name?.toLowerCase()}  </MenuItem>
                    } )
                }
            </Menu>
        </Box>
    )
}

SelectInstitute.propTypes = {
    onSelect: PropTypes.func.isRequired,
}

export default SelectInstitute